import { render } from "./PresencesTable.vue?vue&type=template&id=018ecc9a&scoped=true"
import script from "./PresencesTable.vue?vue&type=script&lang=js"
export * from "./PresencesTable.vue?vue&type=script&lang=js"

import "./PresencesTable.vue?vue&type=style&index=0&id=018ecc9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-018ecc9a"]])

export default __exports__